import { Button } from "@dune/ui";
import { useRequiredParams } from "../../../../hooks/useRequiredParams";
import { ConstructionSiteInfo } from "../components/ConstructionSiteInfo";
import { DesignersControlTable } from "../components/DesignersControlTable";
import { SupportingDocumentsControl } from "../components/SupportingDocumentsControl";
import { useGetConstructionSiteAnalysisData } from "../hooks/useConstructionSiteAnalysisData";

interface ControlsStepProps {
	handleNextStep: () => void;
	handleClose: () => void;
}

export const ControlsStep = ({
	handleNextStep,
	handleClose,
}: ControlsStepProps) => {
	const { constructionSiteId } = useRequiredParams<{
		constructionSiteId: string;
	}>();

	const {
		data: constructionSiteData,
		isLoading,
		error,
	} = useGetConstructionSiteAnalysisData(Number(constructionSiteId));

	if (isLoading) {
		return <div className="p-6">Chargement des données d'analyse...</div>;
	}

	if (error || !constructionSiteData) {
		return (
			<div className="flex flex-col items-center justify-center p-12">
				<p className="text-red-600">
					Erreur lors du chargement des données d'analyse
				</p>
				<Button
					className="mt-4"
					onClick={() => window.location.reload()}
					variant="secondary"
				>
					Réessayer
				</Button>
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-8 p-6">
			<h2 className="text-2xl font-medium text-text-secondary-blue">
				Contrôles
			</h2>

			{/* TODO: Add loading states */}
			<ConstructionSiteInfo data={constructionSiteData} />

			<div className="flex flex-col gap-4">
				{/* Concepteurs Section */}
				<div className="flex flex-col gap-4">
					<div className="flex flex-row gap-4 items-center">
						<div className="flex flex-col min-w-[200px] w-[280px] max-w-[280px]">
							<h3 className="text-base font-medium text-text-secondary-blue uppercase">
								Concepteurs
							</h3>
						</div>
					</div>
					<div className="flex flex-row gap-6">
						<DesignersControlTable
							constructionSiteData={constructionSiteData}
						/>
					</div>
				</div>

				{/* Divider */}
				<div className="h-px bg-[#eaecf0] w-full" />

				{/* Pièces Justificatives Section */}
				<div className="flex flex-col gap-4">
					<div className="flex flex-col">
						<h3 className="text-base font-medium text-text-secondary-blue uppercase">
							Pièces justificatives
						</h3>
					</div>
					<SupportingDocumentsControl context="submission" />
				</div>

				{/* Action Buttons */}
				<div className="flex flex-row h-11 items-center justify-between w-full">
					<div className="bg-white opacity-0 rounded-lg">
						<div className="flex flex-row gap-1.5 items-center justify-center px-4 py-2.5">
							<div className="text-[#414651] text-base font-semibold whitespace-pre">
								Précédent
							</div>
						</div>
					</div>
					<div className="flex flex-row gap-4 items-center">
						<Button
							variant="outline"
							className="text-[#0a7194] border-[#63e6fd]"
							onClick={handleClose}
						>
							Enregistrer et fermer
						</Button>
						<Button
							onClick={handleNextStep}
							className="bg-[#038eb7] text-white"
						>
							Suivant
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};
